export const dateService = {
  formatDate(date: Date): string {
    const day: string = String(date.getDate()).padStart(2, '0');
    const month: string = String(date.getMonth() + 1).padStart(2, '0');
    const year: number = date.getFullYear();

    return `${day}.${month}.${year}`;
  },

  parseApiDate(value: string | null | undefined): Date | null {
    if (!value) {
      return null;
    }

    const date = new Date(value.replace(' ', 'T'));

    return isNaN(date.getTime()) ? null : date;
  },

  getCurrentDate(): Date {
    const today: Date = new Date();
    return new Date(today.getFullYear(), today.getMonth(), today.getDate());
  },

  getNextBusinessYearStart(): Date {
    const today: Date = new Date();
    const currentYear: number = today.getFullYear();
    const nextBusinessYearStart: Date = new Date(Date.UTC(currentYear, 7, 1));

    if (today >= nextBusinessYearStart) {
      nextBusinessYearStart.setFullYear(currentYear + 1);
    }

    return nextBusinessYearStart;
  },

  getNextMonth(): Date {
    const today: Date = new Date();
    return new Date(today.getFullYear(), today.getMonth() + 1, 1);
  },

  toLocalDateString(date: Date): string {
    const timezoneOffset = new Date().getTimezoneOffset() * 60000;

    return new Date(date.valueOf() - timezoneOffset).toISOString().slice(0, -14);
  }
};
